import { create } from 'zustand';
import { devtools } from 'zustand/middleware'
import { Filters } from '../../types/filters';

interface FilterStore {
  selected: Filters,
  selectFilter: <t>(filter: keyof Filters, value: t) => void;
  selectFilters: (filters: Filters) => void;
}

export const useSelectedFilterStore = create<FilterStore>()(devtools((set) => ({
  selected: {
    category: ["new", "used"],
    model: [],
    distance: 100,
    dealer: [],
    vehicle_type: [],
    price: undefined,
    year: undefined,
    mileage: undefined,
    trimline: [],
    transmission: [],
    color_exterior: [],
    color_interior: [],
    in_stock: false,
    limit: 20
  },
  selectFilter: (filter, value) => set((state) => ({
      selected: {
        ...state.selected,
        [filter]: value
      }
    }
  )),
  selectFilters: (filters) => set((state) => ({
      selected: {
        ...state.selected,
        ...filters
      }
    }
  ))
})));
